export default __webpack_public_path__ + "static/media/Deniz Saygili - Director of Finance.a080eca8.jpg";